var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { useAtomValue } from 'jotai';
import { useLoaderData } from 'react-router';
import { formatTemplatesToOptions } from "../../../../../utils/formatters";
import { MultiselectList, defaultSearch } from "../../../../../../../../Components/Forms";
import { templatesAtom } from "../../../../../../../../atoms";

import { useCreateExtractorContext } from "../../CreateExtractorContext";

const Body = () => {
  const { extractors = [] } = useLoaderData();


  const { sourceTemplateId, setSourceTemplateId, targetTemplateId } = useCreateExtractorContext();
  const templates = useAtomValue(templatesAtom);
  const sourceTemplateOptions = formatTemplatesToOptions(
    templates.
    filter((template) => template._id !== targetTemplateId).
    filter(
      (template) => !extractors.some((extractor) => extractor.sourceTemplateId === template._id)
    )
  );
  const [options, setOptions] = useState(sourceTemplateOptions);

  return (/*#__PURE__*/
    _jsx("div", { className: "h-96 pt-2" }, void 0, /*#__PURE__*/
    _jsx(MultiselectList, {
      selectedValues: [sourceTemplateId],
      items: options,
      onChange: (selected) => {
        setSourceTemplateId(selected[0]);
      },
      onSearch: (s) => setOptions(() => defaultSearch(s, sourceTemplateOptions)),
      allowSelelectAll: false,
      singleSelect: true,
      hideFilters: true }
    )
    ));

};

export { Body };